import { render, staticRenderFns } from "./ListItemSave.vue?vue&type=template&id=1bb9bbe5&scoped=true&lang=pug"
import script from "./ListItemSave.vue?vue&type=script&lang=js"
export * from "./ListItemSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb9bbe5",
  null
  
)

export default component.exports